export const PHONE = "8669361526";
export const PHONE_DISPLAY = "+91 86693 61526";
export const WHATSAPP_URL = "https://wa.me/918669361526";
export const LINKEDIN_URL = "https://www.linkedin.com/in/sachinjaybhaye";
export const EMAIL = "apratimgroup@gmail.com";
export const ADDRESS_AURANGABAD = "Apratim Park, Opp. Chate School, Beed Bypass, Chhatrapati Sambhaji Nagar (Aurangabad), Maharashtra";
export const ADDRESS_PUNE = "Pune, Maharashtra";

export const LOGO_JAYBHAYE =
  "https://customer-assets-lqy194kg.emergentagent.net/job_82459c39-cff9-4a65-887c-e2e43d816e57/artifacts/7a6eps9j_logo%20final.png";
export const LOGO_APRATIM =
  "https://customer-assets-lqy194kg.emergentagent.net/job_82459c39-cff9-4a65-887c-e2e43d816e57/artifacts/gcaib6tp_db47200ed57b594650c0fd68540f39d0.png";

export const STATS = [
  { value: 15, suffix: "+", label: "Years of Experience" },
  { value: 900, suffix: "+", label: "Homes / Families" },
  { value: 15, suffix: "+", label: "Acres Developed" },
  { value: 2, suffix: "", label: "Key Markets — Aurangabad + Pune" },
];

export const PILLARS = [
  {
    numeral: "I",
    title: "Experience",
    text: "15+ years in real estate development through the Apratim Group legacy — grounded in delivered communities, not promises.",
  },
  {
    numeral: "II",
    title: "Integrity",
    text: "Our guiding principle is Growing with Integrity. Every boundary clearly marked, every approval verified, every agreement honoured.",
  },
  {
    numeral: "III",
    title: "Execution",
    text: "Hands-on experience across residential, commercial and plotted developments in Chhatrapati Sambhaji Nagar.",
  },
  {
    numeral: "IV",
    title: "Relationships",
    text: "Long-term relationships with customers, landowners, partners and stakeholders — goodwill is our real net worth.",
  },
  {
    numeral: "V",
    title: "Vision",
    text: "Building a modern real-estate development platform for the next generation, expanding from Aurangabad into Pune.",
  },
];

export const PROJECTS = [
  {
    slug: "apratim-radhai-estate",
    name: "Apratim Radhai Estate",
    location: "Gat No. 17, 20, Fatehpur, Near ISKCON Temple, Jalna Road, Chhatrapati Sambhaji Nagar",
    type: "NA-44 Approved Residential Plots",
    status: "Ready Possession",
    developer: "Delivered by Apratim Builders",
    tagline:
      "A fully-serviced, CIDCO NA-44 approved plotting community on Jalna Road — the site just 100 metres from the highway.",
    story:
      "Apratim Radhai Estate is a thoughtfully planned residential plotting development at Fatehpur, moments from the ISKCON Temple on Jalna Road. Every plot is NA-44 approved and vastu-planned, served by a grand entrance gate with security cabin, internal concrete roads, LED street lighting and drainage lines. With a garden, children's play area and plots ranging from 600 to 5,000 sq. ft., it offers families a peaceful, well-connected setting to build the home they imagine — minutes from schools, colleges and the city airport.",
    highlights: [
      "CIDCO NA-44 approved residential plots — clear, verified titles",
      "Vastu-planned plots from 600 to 5,000 sq. ft.",
      "Site just 100 metres from Jalna Road",
      "Grand entrance gate with security cabin",
      "Internal concrete roads, LED street lights and drainage line",
      "Garden and children's play area",
      "Near ISKCON Temple, schools, colleges and the city airport",
    ],
    image: "/assets/radhai-cover.jpg",
    gallery: ["/assets/radhai-layout.jpg"],
    brochureUrl:
      "https://customer-assets-rejwkqb3.emergentagent.net/job_growing-integrity/artifacts/0xk4ud4h_apratim%20radhai.pdf",
    mapUrl: "https://maps.app.goo.gl/aohvHTTMy3dDyW8s9",
  },
  {
    slug: "apratim-park",
    name: "Apratim Park",
    location: "Opp. Chate School, Beed Bypass, Chhatrapati Sambhaji Nagar",
    type: "Apartments & Commercial — 1, 2 & 3 BHK + Shops",
    status: "Ready Possession",
    developer: "Delivered by Apratim Builders",
    rera: "MahaRERA No. P51500002890",
    tagline:
      "1, 2 & 3 BHK residences and commercial shops on the Beed Bypass — engineered for comfort, built to last.",
    story:
      "Positioned opposite Chate School on the Beed Bypass, Apratim Park combines 1, 2 and 3 BHK residences with ground-level commercial shops in one of the city's most connected corridors. Every flat enjoys a 2-metre-wide covered balcony, natural cross-ventilation and considered detailing — vitrified flooring, black granite kitchen platforms, Jaquar bathroom fittings and concealed wiring throughout. With a lift, basement and ground-floor parking, rainwater harvesting and a children's play area, it is a complete urban address built with robust RCC construction.",
    highlights: [
      "1, 2 & 3 BHK apartments plus commercial shops",
      "MahaRERA registered — No. P51500002890",
      "2-metre-wide covered balcony for every flat",
      "Lift, basement and ground-floor parking",
      "Children's play area and rainwater harvesting",
      "Vitrified flooring, granite kitchen platforms, Jaquar fittings",
      "Opposite Chate School on the Beed Bypass corridor",
    ],
    image: "/assets/park-street.jpg",
    heroImage: "/assets/park-street.jpg",
    gallery: [
      "/assets/park-interior-living.jpg",
      "/assets/park-interior-kitchen.jpg",
      "/assets/park-interior-ceiling.jpg",
      "/assets/park-cover.jpg",
      "/assets/park-floorplan.jpg",
    ],
    brochureUrl:
      "https://customer-assets-rejwkqb3.emergentagent.net/job_growing-integrity/artifacts/dbhp8arc_Apratim%20park%20.pdf",
    mapUrl: "https://maps.app.goo.gl/agxUbGbv2PbQTN1bA",
  },
  {
    slug: "apratim-vastu",
    name: "Apratim Vastu",
    location: "Chhatrapati Sambhaji Nagar (Aurangabad)",
    type: "Harmonious Living",
    status: "Ready Possession",
    developer: "Delivered by Apratim Group",
    tagline:
      "Vastu-aligned residential development built around light, air, and thoughtful spatial flow for multigenerational families.",
    story:
      "Apratim Vastu was planned around a simple belief: homes should breathe. Vastu-aligned orientations, generous daylight and considered spatial flow make these residences comfortable for every generation under one roof.",
    highlights: [
      "Vastu-aligned planning and orientations",
      "Daylight and ventilation-first layouts",
      "Designed for multigenerational families",
      "Established community",
    ],
    image:
      "https://customer-assets-lqy194kg.emergentagent.net/job_82459c39-cff9-4a65-887c-e2e43d816e57/artifacts/yebd4lm9_download%20%281%29.jpeg",
    heroImage: "/assets/vastu-aerial.jpg",
    gallery: ["/assets/vastu-aerial.jpg"],
    mapUrl: "https://maps.app.goo.gl/doszE7wCtuH8vcWu7",
  },
  {
    slug: "apratim-pushp",
    name: "Apratim Pushp",
    location: "Chhatrapati Sambhaji Nagar (Aurangabad)",
    type: "Residential Row Houses",
    status: "Ready Possession",
    developer: "Delivered by Apratim Group",
    tagline:
      "A completed row-house community by Apratim Group — settled homes in a planned neighbourhood.",
    story:
      "Apratim Pushp is one of the Apratim Group's delivered row-house communities in Chhatrapati Sambhaji Nagar — uniform, thoughtfully planned homes that today form a settled residential neighbourhood. Detailed project documentation will be added to this page shortly.",
    highlights: [
      "Delivered row-house community",
      "Planned, uniform neighbourhood layout",
      "Established and occupied residences",
    ],
    image:
      "https://customer-assets-lqy194kg.emergentagent.net/job_82459c39-cff9-4a65-887c-e2e43d816e57/artifacts/cvqf6goa_project_image_2_med.jpg",
    mapUrl: null,
  },
  {
    slug: "pune-developments",
    name: "Pune Developments",
    location: "Baner · Bhugaon · Bavdhan · Hinjewadi · Kondhwa · Salisbury Park",
    type: "Residential & Joint Development",
    status: "Upcoming",
    developer: "Jaybhaye Realty Pvt. Ltd.",
    tagline:
      "The next chapter: thoughtfully planned developments across Pune's premier growth corridors.",
    story:
      "Jaybhaye Realty Pvt. Ltd. is carrying the Apratim legacy into Pune. The company is actively evaluating and partnering across the city's western and southern growth belts — working with landowners through transparent joint-development models.",
    highlights: [
      "Focus micro-markets: Baner, Bhugaon, Bavdhan, Hinjewadi, Kondhwa, Salisbury Park",
      "Joint development partnerships with landowners",
      "15+ years of delivered experience behind every new venture",
      "Announcements to follow as projects are finalised",
    ],
    image: null,
    mapUrl: null,
  },
];

export const DIRECTORS = [
  {
    initials: "GPJ",
    name: "Ganesh P. Jaybhaye",
    role: "Founder & Chairman, Apratim Group",
    tagline: "The foundation on which the journey was built.",
    photo: "/assets/director-ganesh.jpg",
    bio: "The driving force behind the Apratim Group legacy — a culture of trust, relationships, disciplined execution and long-term thinking built over 15+ years in real estate development.",
    fullBio: [
      "Ganesh P. Jaybhaye is the driving force behind the legacy of Apratim Group and the foundation upon which the group's real estate journey has been built.",
      "With a long-standing presence in real estate development, he has been instrumental in establishing a culture centred around trust, relationships, disciplined execution and long-term thinking.",
      "His approach to business has always been rooted in the belief that real estate is ultimately a business of relationships. Every project represents a commitment to customers, landowners, partners and the communities in which the company operates.",
      "Through the years, this philosophy has shaped the group's journey and created the foundation for Jaybhaye Realty Pvt. Ltd. to carry the business into its next phase.",
      "Today, the next generation continues this journey with the same underlying values, while bringing a renewed focus on contemporary development, new markets and evolving opportunities in the real estate sector.",
    ],
    closing: "Legacy creates the foundation. The next generation builds upon it.",
  },
  {
    initials: "SGJ",
    name: "Sachin Ganesh Jaybhaye",
    role: "Director, Jaybhaye Realty Pvt. Ltd.",
    tagline: "Building on a legacy. Shaping what comes next.",
    photo: "/assets/director-sachin.jpg",
    bio: "Next-generation leadership — combining practical development and execution experience with a focus on design, partnerships and the company's Pune expansion.",
    fullBio: [
      "Sachin Ganesh Jaybhaye represents the next generation of leadership at Jaybhaye Realty Pvt. Ltd., bringing together a strong understanding of real estate, a contemporary approach to development and a vision for building the company into a larger, professionally driven real estate platform.",
      "Coming from a family with a long-standing presence in real estate development, Sachin has been closely exposed to the business from an early stage. His approach combines the practical understanding of development and execution with a strong focus on design, market opportunity, partnerships and long-term value creation.",
      "Under his leadership, Jaybhaye Realty is looking beyond its established roots in Aurangabad / Sambhaji Nagar and exploring opportunities in Pune and other high-growth markets across Maharashtra.",
      "His vision is to build developments that are not only commercially successful, but also thoughtfully planned, responsibly executed and capable of creating lasting value for customers, landowners, investors and partners.",
      "For Sachin, the next chapter of the business is about carrying forward the principles that built the foundation — while bringing a new generation's ambition, technology and perspective to real estate.",
    ],
    closing: "His guiding philosophy: Growing with Integrity.",
  },
];

export const PUNE_MARKETS = [
  { name: "Baner", note: "Commercial & Prime Residential" },
  { name: "Bavdhan", note: "Scenic Western Corridor" },
  { name: "Bhugaon", note: "Nature Integrated Living" },
  { name: "Hinjewadi", note: "Tech Corridor Infrastructure" },
  { name: "Kondhwa", note: "High-Density Urban Growth" },
  { name: "Salisbury Park", note: "Central Heritage Residential" },
];

export const INSIGHTS = [
  {
    slug: "pune-expansion",
    category: "Company Announcement",
    title: "Jaybhaye Realty Pvt. Ltd. expands its development footprint into Pune",
    excerpt:
      "Building on 15+ years of delivered work in Chhatrapati Sambhaji Nagar, the company is now active across Pune's key growth corridors — Baner, Bhugaon, Bavdhan, Hinjewadi, Kondhwa and Salisbury Park.",
  },
  {
    slug: "radhai-estate-ready",
    category: "Project Update",
    title: "Apratim Radhai Estate — ready possession in Chhatrapati Sambhaji Nagar",
    excerpt:
      "The Apratim Group's gated residential community is delivered and occupied, with complete infrastructure and clear titles.",
  },
  {
    slug: "apratim-park-ready",
    category: "Project Update",
    title: "Apratim Park, Beed Bypass — ready homes on the city's growth corridor",
    excerpt:
      "Apratim Park offers ready-possession residences along the Beed Bypass, combining connectivity with durable construction.",
  },
  {
    slug: "landowner-partnerships",
    category: "Partnerships",
    title: "Landowner & joint-development partnerships now open in Pune",
    excerpt:
      "Jaybhaye Realty invites landowners in Pune's western and southern belts to explore transparent joint-development partnerships backed by a 900+ family track record.",
  },
];

export const ENQUIRY_TYPES = [
  { value: "project-enquiry", label: "Project Enquiry (Aurangabad / Pune)" },
  { value: "landowner-partnership", label: "Landowner / Development Partnership" },
  { value: "investor-enquiry", label: "Investor Enquiry" },
  { value: "general-enquiry", label: "General Enquiry" },
];
